import React, { useEffect, useState } from "react";
import { decryptKuznechik, encryptKuznechik, getKeyKuznechik, newGenKeyKuznechik } from "../../routes/kuznechik";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";


const ecription_mode = ['ecb', 'cfb', 'ofb', 'ctr', 'cbc']

const Kuznechik = () => {

    const [value, setValue] = useState({
        key: '',
        enc_data: '',
        dec_data: '',
        enc_mode: 'ecb'
    })


    useEffect(() => {
        getKeyKuznechik().then(res => {
            if (res.status === 200) {
                setValue(data => {
                    return {
                        ...data,
                        key: res.data
                    }
                })
            }
        })
    }, [])


    const handleUpdateKey = (e) => {
        newGenKeyKuznechik().then(res => {
            if (res.status === 200) {
                setValue(data => {
                    return {
                        ...data,
                        key: res.data
                    }
                })
            }
        })
    }

    const handleInputChange = (e) => {
        setValue(data => {
            return {
                ...data,
                [e.target.name]: e.target.value
            }
        });
    }


    const handleEncriptData = () => {
        setValue(data => {
            return {
                ...data,
                dec_data: '',
            }
        })
        encryptKuznechik(value.enc_mode.toLowerCase(), value.key, value.enc_data).then(res => {
            if (res.status === 200)
                setValue(data => {
                    return {
                        ...data,
                        dec_data: res.data,
                        enc_data: ''
                    }
                })
        })
    }
    const handleDecryptData = (e) => {
        decryptKuznechik(value.enc_mode.toLowerCase(), value.key, value.dec_data).then(res => {
            if (res.status === 200) {
                setValue(data => {
                    return {
                        ...data,
                        enc_data: res.data,
                    }
                })

            }
        })
    }
    return (
        <div id='kuznechik' >
            <h5 style={{
                textAlign: 'center',
                lineHeight: '25px'
            }}>
                <div>
                    Реализация алгоритма ГОСТ 34.12-2015
                </div>
                <div>
                    "Кузнечик"
                </div>
            </h5>

            <div className="input_box" style={{ marginTop: '30px' }}>
                <Form >
                    <Form.Label>Ключ шифрования</Form.Label>
                    <InputGroup className="mb-3">
                        <Form.Control
                            type="text"
                            name='key'
                            value={value.key.length > 0 ? value.key.toLocaleUpperCase() : value.key}
                            onChange={handleInputChange}
                            placeholder="Ключ шифрования"
                            style={{ color: "white" }}
                        />
                        <InputGroup.Text
                            onClick={handleUpdateKey}
                            style={{
                                borderTopLeftRadius: '0',
                                borderBottomLeftRadius: '0',
                                cursor: 'pointer'
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                                <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z" />
                            </svg>
                        </InputGroup.Text>
                    </InputGroup>
                    <Form.Group>
                        <Form.Label>Режим шифрования</Form.Label>
                        <Form.Control
                            name='enc_mode'
                            onChange={handleInputChange}
                            defaultValue={value.enc_mode}
                            as="select"
                            style={{ backgroundColor: 'unset', color: '#fff' }}
                        >
                            {
                                ecription_mode.map((item, index) => <option key={index}>{item.toUpperCase()}</option>)
                            }
                        </Form.Control>
                    </Form.Group>

                    <Form.Group >
                        <Form.Label>Открытые данные</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name='enc_data'
                            value={value.enc_data}
                            onChange={handleInputChange}
                            placeholder="Введите текст для шифрования"
                            style={{ color: "#fff", backgroundColor: 'unset' }}
                        />
                    </Form.Group>
                    <Form.Group>
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{
                                width: '45%'
                            }}>
                                <Button
                                    style={{ width: '100%' }}
                                    onClick={handleEncriptData}
                                    disabled={value.enc_data.length === 0}
                                >
                                    Зашифровать
                                </Button>
                            </div>
                            <div style={{
                                width: '45%'
                            }}>
                                <Button
                                    style={{ width: '100%' }}
                                    onClick={handleDecryptData}
                                    disabled={value.dec_data.length === 0}
                                >
                                    Расшифровать
                                </Button>
                            </div>

                        </div>

                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Зашифрованные данные</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name='dec_data'
                            value={value.dec_data.length > 0 ? value.dec_data.toLocaleUpperCase() : value.dec_data}
                            onChange={handleInputChange}
                            placeholder="Зашифрованные данные"
                            style={{ color: "#fff", backgroundColor: 'unset' }}
                        />
                    </Form.Group>
                </Form>
            </div>
        </div>
    );
};

export default Kuznechik;
